import BenchlingConfig from 'BenchlingConfig';
import EntityStore from 'stores/EntityStore';

import {RoutineRunAs, type RoutineCreator} from './RoutineTypes';

interface RoutineExecutionIdentity {
  creatorId?: string | null;
  creator?: RoutineCreator | null;
  runAs: RoutineRunAs;
}

function routineCreatorId(routine: RoutineExecutionIdentity): string | null {
  return routine.creatorId ?? routine.creator?.id ?? null;
}

type RoutineModificationAction = 'edit' | 'pause' | 'resume' | 'run';

export function isRoutineRunAsDisabled(runAs: RoutineRunAs): boolean {
  return BenchlingConfig.LLM_ROUTINES_READ_ONLY_RUN_AS_MODES.includes(runAs);
}

export function getSelectableRunAsModes(): Array<RoutineRunAs> {
  return [
    RoutineRunAs.CREATOR,
    ...(BenchlingConfig.LLM_ENABLE_ROUTINES_RUN_AS_SERVICE_ACCOUNT ? [RoutineRunAs.SERVICE_ACCOUNT] : []),
  ].filter((runAs) => !isRoutineRunAsDisabled(runAs));
}

export function canCurrentUserModifyRoutine(
  routine: RoutineExecutionIdentity,
  action: RoutineModificationAction
): boolean {
  if (action === 'pause' || routine.runAs !== RoutineRunAs.CREATOR) {
    return true;
  }
  const creatorId = routineCreatorId(routine);
  return creatorId != null && creatorId === EntityStore.currentUser()?.id;
}
